import type { PortalProfile } from '../auth/types'

// Flaga „Modelu stawek" przychodzi w /api/me jako profile.features.rateModel — flaga per FIRMA
// (w odróżnieniu od per-user modules.statistics company master jej NIE omija). Brak pola
// (stary backend / deploy skew) = funkcja wyłączona, UI w ogóle się nie renderuje.
export const hasRateModelAccess = (profile: PortalProfile | null | undefined): boolean =>
  profile?.features?.rateModel === true
